<div class="modal-header workspace-upgrade-modal-header">
  <h3 class="workspace-upgrade-modal-title">{{'workspace_upgrade_modal_title' | translate}}</h3>
  <img src="assets/svg/close-button.svg" alt="X" aria-label="Close" class="modal-close-btn" (click)="close()">
</div>
<div class="modal-body workspace-upgrade-modal-body" *ngIf="data.userRole?.role.workspacePriority !== 40">
  <img class="man-with-rocket" src="../../../assets/images/man-with-rocket.png">
  <p class="text-center" style="font-size: 1.6rem;">{{'workspace_upgrade_modal_member_title' | translate}}</p>
  <p class="text-center workspace-upgrade-info"
     [innerHTML]="('workspace_upgrade_modal_member_info' | translate: {creator: creatorName, date: limitReachedDate})"></p>
  <button pButton type="button" class="workspace-upgrade-button" style="font-family: Poppins, sans-serif;"
          (click)="goToDashboard()">{{'workspace_upgrade_modal_see_dashboard_btn' | translate}}
  </button>
</div>
<div class="modal-body workspace-upgrade-modal-body" *ngIf="data.userRole?.role.workspacePriority === 40">
  <img class="man-with-rocket" src="../../../assets/images/man-with-rocket.png">
  <p class="text-center" style="font-size: 1.6rem;">{{'workspace_upgrade_modal_owner_title' | translate}}</p>
  <p class="text-center workspace-upgrade-info"
     [innerHTML]="('workspace_upgrade_modal_owner_info' | translate: {date: limitReachedDate})"></p>
  <button pButton type="button" class="workspace-upgrade-button" style="font-family: Poppins, sans-serif;"
          (click)="goToBilling()">{{'left_menu_button'| translate}}
  </button>
  <p class="text-center" style="font-size: 1.5rem; margin-top: 1rem;">{{'workspace_upgrade_modal_price' | translate}}</p>
</div>
